module.exports = __webpack_public_path__ + "media/icon/icon-local_laundry_service-green-277b273b.svg";